var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgResultsMessaging = function SvgResultsMessaging(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343754",
    fillRule: "nonzero",
    d: "M9.036 1.636c-4.005 0-7.393 2.25-7.393 4.909 0 1.406.95 2.76 2.592 3.706l1.245.716-.449 1.074c.27-.154.54-.32.796-.499l.565-.396.68.128a11.11 11.11 0 0 0 1.964.179c4.004 0 7.393-2.25 7.393-4.908 0-2.66-3.389-4.909-7.393-4.909zm10.383 2.966C21.59 5.79 23 7.682 23 9.817c0 2.083-1.335 3.924-3.414 5.125.436 1.061 1.001 1.56 1.502 2.122.14.166.308.32.256.563-.051.23-.244.396-.449.37a9.398 9.398 0 0 1-1.104-.204 10.796 10.796 0 0 1-3.568-1.636c-.719.128-1.476.204-2.259.204-2.323 0-4.453-.639-6.058-1.687.372.026.758.051 1.13.051 2.76 0 5.365-.792 7.354-2.224 2.143-1.56 3.324-3.668 3.324-5.956 0-.665-.102-1.317-.295-1.943zM9.036 0c4.992 0 9.035 2.927 9.035 6.545 0 3.617-4.043 6.544-9.035 6.544-.783 0-1.54-.077-2.26-.204A10.796 10.796 0 0 1 3.21 14.52c-.347.09-.719.153-1.104.204h-.039c-.192 0-.372-.153-.41-.37-.052-.243.115-.397.256-.563.5-.562 1.066-1.06 1.502-2.122C1.334 10.47 0 8.615 0 6.545 0 2.927 4.043 0 9.036 0z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResultsMessaging, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/results-messaging.33bd59e7.svg";
export { ForwardRef as ReactComponent };